$(document).ready(function(){
    $('.js-videoSlider').slick({
        dots: false,
        vertical: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        verticalSwiping: true,
        infinite: false
    });

    $('.js-videoSlider').each(function(){
        if ( $(this).find($('.slick-slide')).length > 3 ) {
        } else {
            $(this).parent().parent().addClass('short');
        }
    });
    
    
    $("[data-videourl]").on("click", function () {
        var el = $(this);
        var url = el.data("videourl");
        $('[data-target]').attr("src", url);
        $('.videoSlide .slick-slide').removeClass('slick-current');
        el.closest('.slick-slide').addClass('slick-current');
    });
    
    $("[data-videourl]").eq(0).trigger("click");
});